export const parseEndOfDayFromQueryParam = (value: string | null) => {
  if (!value) {
    return undefined;
  }

  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    return undefined;
  }

  const date = new Date(`${value}T23:59:59`);
  date.setHours(23, 59, 59, 999);
  if (!Number.isFinite(date.getTime())) {
    return undefined;
  }

  return date;
};
